import { Router } from '@angular/router';
import { CRUD_ROUTE_STATE_ITEM_DEFAULTS, CRUD_ROUTE_STATE_LIST } from '@common/crud/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export let DisplayMembershipModelActionService = /*#__PURE__*/(() => {
  class DisplayMembershipModelActionService {
    constructor(router) {
      this.router = router;
    }
    displayMembershipsOfUser(userId) {
      const state = {
        [CRUD_ROUTE_STATE_LIST]: {
          filters: {
            ownerId: userId
          }
        }
      };
      this.router.navigate(['/membership/membership'], {
        state
      });
    }
    createMembershipForUser(userId) {
      const state = {
        [CRUD_ROUTE_STATE_ITEM_DEFAULTS]: {
          ownerId: userId
        }
      };
      this.router.navigate(['/membership/membership/new'], {
        state
      });
    }
    static {
      this.ɵfac = function DisplayMembershipModelActionService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DisplayMembershipModelActionService)(i0.ɵɵinject(i1.Router));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DisplayMembershipModelActionService,
        factory: DisplayMembershipModelActionService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DisplayMembershipModelActionService;
})();